// Copyright (c) 2017 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetFilters = () => getDefaultState().searchFilters;

const updateListFilterBy = (state, action) =>
    SearchFilters.update(state, {
        filterBy: {
            $set: action.filterBy
        }
    });

const updateListSortBy = (state, action) =>
    SearchFilters.update(state, {
        sortBy: {
            $set: action.sortBy
        }
    });

const updateListSortDirection = (state, action) =>
    SearchFilters.update(state, {
        sortDirection: {
            $set: action.sortDirection
        }
    });

export default (state = getDefaultState().searchFilters, action) => {

    const actionTypes = {
        [actions.RESET_LABOR_RATE_DEALERS_FILTERS]: resetFilters,
        [actions.UPDATE_LABOR_RATE_DEALERS_FILTER_BY]: updateListFilterBy,
        [actions.UPDATE_LABOR_RATE_DEALERS_SORT_BY]: updateListSortBy,
        [actions.UPDATE_LABOR_RATE_DEALERS_SORT_DIRECTION]: updateListSortDirection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/search-filters.js